import { ref } from 'vue'
import { defineStore } from 'pinia'
import { ISettingsParams, IUserSettings } from '@src/types/user.types'
import userApi from '@src/api/user'

export const useUserSettingsStore = defineStore('userSettings', () => {
  const loading = ref(true)
  const error = ref(false)
  const settings = ref<IUserSettings | Record<string, never>>({})

  async function load() {
    loading.value = true
    error.value = false

    try {
      const { data: userSettings } = await userApi.cached.getSettings()
      settings.value = userSettings
    } catch {
      error.value = true
    } finally {
      loading.value = false
    }

    return settings.value
  }

  async function update(newSettings: Partial<ISettingsParams>): Promise<void> {
    loading.value = true
    error.value = false

    try {
      const { data: userSettings } = await userApi.updateSettings(newSettings)
      settings.value = userSettings
    } catch {
      error.value = true
    } finally {
      loading.value = false
    }
  }

  return {
    loading,
    error,
    settings,
    load,
    update
  }
})
